import { useMemo } from "react";
import { createAuthHttpClient } from "../../../features/auth/authHttp";

export const useBillingApiClient = () =>
  useMemo(
    () =>
      createAuthHttpClient({
        timeout: 15000,
      }),
    []
  );
